import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'app-fr-detail-contenu-document',
    templateUrl: './fr-detail-contenu-document.component.html',
    styleUrls: ['./fr-detail-contenu-document.component.scss']
})
export class FrDetailContenuDocumentComponent implements OnInit {
    reference: string | null = null;
    selectedTab: string = 'commande-fournisseur';

    constructor(private router: Router, private route: ActivatedRoute) {}

    ngOnInit(): void {
        this.route.paramMap.subscribe(params => {
            this.reference = params.get('reference');
            if (!this.reference && this.route.parent) {
                this.reference = this.route.parent.snapshot.paramMap.get('reference');
            }

            if (!this.reference) {
                console.error('FrDetailContenuDocumentComponent: No reference found');
                this.router.navigate(['/bibliotheque-fournisseurs/actif']);
                return;
            }

            const validTabs = ['commande-fournisseur', 'facture-fournisseur', 'bon-reception'];
            const savedTab = localStorage.getItem('selectedDocumentTab');
            const currentUrl = this.router.url;

            let currentTab = 'commande-fournisseur';
            if (currentUrl.includes('/facture-fournisseur')) {
                currentTab = 'facture-fournisseur';
            } else if (currentUrl.includes('/bon-reception')) {
                currentTab = 'bon-reception';
            }

            this.selectedTab = savedTab && validTabs.includes(savedTab) ? savedTab : currentTab;

            if (this.router.url === `/tiers/fournisseurs/details/${this.reference}/detail-contenue-document`) {
                this.router.navigate([`/tiers/fournisseurs/details/${this.reference}/detail-contenue-document/commande-fournisseur`], {
                    replaceUrl: true
                });
            }
        });
    }

    selectTab(tab: string): void {
        this.selectedTab = tab;
        localStorage.setItem('selectedDocumentTab', tab);
        if (this.reference) {
            this.router.navigate([`/tiers/fournisseurs/details/${this.reference}/detail-contenue-document/${tab}`], {
                replaceUrl: true
            });
            console.log('FrDetailContenuDocumentComponent: Navigated to tab:', tab);
        } else {
            console.error('FrDetailContenuDocumentComponent: Cannot navigate: reference is null');
            this.router.navigate(['/bibliotheque-fournisseurs/actif']);
        }
    }
}
